namespace advisorop.components.servicer {

    class CUAccountNumbersController {
        uploadFileOptions: DevExpress.ui.dxFileUploaderOptions;

        static $inject = ["generalService", "identityService", "servicerService"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {

            this.uploadFileOptions = {
                bindingOptions: {
                    value: "vm.uploadFiles",
                    uploadUrl: "vm.uploadUrl"
                    //disabled: "!vm.selDocumentType"
                },
                //uploadUrl: "/api/advisor/uploadaccountdocument/1014/2", //uploadaccountdocument  //uploadinvestordocument
                selectButtonText: "Select document with account numbers",
                labelText: " or Drop file here...",
                multiple: true,
                uploadMode: "useButtons", //useButtons instantly
                accept: "*", //"image/*",
                readyToUploadMessage: "Document is ready for upload",
                //buttonText: "Upload documents <br/> Blah",
                uploadButtonText: "Upload selected documents",
                showFileList: true,
                width: "100%",
                onUploaded: (e) => {
                    //console.log("upload completed...");
                    //this.loadDocuments();
                    //this.selDocumentType = null;
                    //this.uploadFiles = [];
                    toastr.success("Document(s) has been successfully uploaded");
                },

            };
            
        }

        
    }

    class CUAccountNumbers implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = CUAccountNumbersController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/cu-account-numbers.html';
        }
    }
    angular.module(Constants.APP).component("cuAccountNumbers", new CUAccountNumbers());
}